import React from "react";
import MuiButton from "@material-ui/core/Button";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "12px 24px",
    height: "48px",
    borderRadius: "8px",
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: theme.palette.primary.shadow,
      boxShadow: "0 6px 8px 0 rgba(0, 0, 0, 0.1) !important",
    },
    "&:active": {
      backgroundColor: theme.palette.primary.shadow,
      color: "#ffffff",
      opacity: "0.8",
      border: "none",
      boxShadow: "none !important",
    },
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      boxShadow: "0 0px 4px 4px rgba(0, 0, 0, 0.1) !important",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        boxShadow: "0 0px 4px 4px rgba(0, 0, 0, 0.1) !important",
      },
    },
    "&:disabled": {
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      opacity: "0.5",
      border: "none",
      boxShadow: "none !important",
      cursor: "no-drop",
    },
  },
  secondary: {
    backgroundColor: theme.palette.secondary.shadow,
    color: "#ffffff",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: theme.palette.secondary.shadow,
      color: "#ffffff",
      boxShadow: "0 6px 8px 0 rgba(0, 0, 0, 0.1) !important",
    },
    "&:active": {
      backgroundColor: theme.palette.secondary.tint60,
      color: "#ffffff",
      opacity: "0.8",
      border: "none",
      boxShadow: "none !important",
    },
    "&:focus": {
      backgroundColor: theme.palette.secondary.main,
      color: "#ffffff",
      boxShadow: "0 0px 4px 4px rgba(0, 0, 0, 0.1) !important",
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
        color: "#ffffff",
        boxShadow: "0 0px 4px 4px rgba(0, 0, 0, 0.1) !important",
      },
    },
    "&:disabled": {
      backgroundColor: theme.palette.secondary.tint100,
      color: theme.palette.secondary.main,
      opacity: "0.5",
      border: "none",
      boxShadow: "none !important",
      cursor: "no-drop",
    },
  },
  default: {
    backgroundColor: theme.palette.gray2.main,
    color: theme.palette.secondary.main,
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: theme.palette.gray2.main,
      color: theme.palette.secondary.tint90,
      boxShadow: "0 6px 8px 0 rgba(0, 0, 0, 0.1) !important",
    },
    "&:active": {
      backgroundColor: theme.palette.secondary.tint15,
      color: theme.palette.secondary.tint60,
      opacity: "0.8",
      border: "none",
      boxShadow: "none !important",
    },
    "&:focus": {
      backgroundColor: theme.palette.secondary.tint15,
      color: theme.palette.secondary.tint60,
      boxShadow: "0 0px 4px 4px rgba(0, 0, 0, 0.1) !important",
      "&:hover": {
        backgroundColor: theme.palette.secondary.tint15,
        color: theme.palette.secondary.tint60,
        boxShadow: "0 0px 4px 4px rgba(0, 0, 0, 0.1) !important",
      },
    },
    "&:disabled": {
      backgroundColor: theme.palette.gray2.main,
      color: theme.palette.secondary.tint60,
      opacity: "0.5",
      border: "none",
      boxShadow: "none !important",
      cursor: "no-drop",
    },
  },
  teal: {
    backgroundColor: theme.palette.teal.tint35,
    color: theme.palette.teal.main,
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: theme.palette.teal.main,
      color: "#ffffff",
      boxShadow: "0 6px 8px 0 rgba(0, 0, 0, 0.1) !important",
    },
    "&:active": {
      backgroundColor: theme.palette.teal.shadow,
      color: "#ffffff",
      opacity: "0.8",
      border: "none",
      boxShadow: "none !important",
    },
    "&:focus": {
      backgroundColor: theme.palette.teal.main,
      color: "#ffffff",
      boxShadow: "0 0px 4px 4px rgba(0, 0, 0, 0.1) !important",
      "&:hover": {
        backgroundColor: theme.palette.teal.main,
        color: "#ffffff",
        boxShadow: "0 0px 4px 4px rgba(0, 0, 0, 0.1) !important",
      },
    },
    "&:disabled": {
      backgroundColor: theme.palette.teal.tint12,
      color: theme.palette.teal.main,
      border: "none",
      boxShadow: "none !important",
      cursor: "no-drop",
    },
  },
  red2: {
    backgroundColor: theme.palette.red2.main,
    color: "#ffffff",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: theme.palette.red2.shadow,
      boxShadow: "0 6px 8px 0 rgba(0, 0, 0, 0.1) !important",
    },
    "&:active": {
      backgroundColor: theme.palette.red2.shadow,
      color: "#ffffff",
      opacity: "0.8",
      border: "none",
      boxShadow: "none !important",
    },
    "&:focus": {
      backgroundColor: theme.palette.red2.main,
      color: "#ffffff",
      boxShadow: "0 0px 4px 4px rgba(0, 0, 0, 0.1) !important",
      "&:hover": {
        backgroundColor: theme.palette.red2.main,
        color: "#ffffff",
        boxShadow: "0 0px 4px 4px rgba(0, 0, 0, 0.1) !important",
      },
    },
    "&:disabled": {
      backgroundColor: theme.palette.red2.main,
      color: "#ffffff",
      opacity: "0.5",
      border: "none",
      boxShadow: "none !important",
      cursor: "no-drop",
    },
  },
  tertiary: {
    backgroundColor: theme.palette.primary.tint12,
    color: theme.palette.primary.main,
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      boxShadow: "none !important",
    },
    "&:active": {
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      opacity: "0.8",
      border: "none",
      boxShadow: "none !important",
    },
    "&:focus": {
      backgroundColor: theme.palette.primary.tint35,
      color: theme.palette.primary.main,
      boxShadow: "0 0px 4px 4px rgba(0, 0, 0, 0.1) !important",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        boxShadow: "0 0px 4px 4px rgba(0, 0, 0, 0.1) !important",
      },
    },
    "&:disabled": {
      backgroundColor: theme.palette.primary.tint35,
      color: theme.palette.primary.main,
      opacity: "0.2",
      border: "none",
      boxShadow: "none !important",
      cursor: "no-drop",
    },
  },
  white: {
    backgroundColor: theme.palette.white.main,
    color: theme.palette.secondary.tint90,
    boxShadow: "none !important",
    borderWidth: "thin",
    borderColor: theme.palette.secondary.tint15,
    borderStyle: "solid",
    "&:hover": {
      backgroundColor: theme.palette.white.main,
      color: theme.palette.secondary.main,
      boxShadow: "none !important",
      fontWeight: "bold",
      borderWidth: "thin",
      borderColor: theme.palette.teal.main,
      borderStyle: "solid",
    },
    "&:active": {
      backgroundColor: theme.palette.white.main,
      color: theme.palette.secondary.main,
      opacity: "0.8",
      border: "none",
      boxShadow: "3px #e6f7fd !important",
      fontWeight: "bold",
      borderWidth: "thin",
      borderColor: theme.palette.teal.main,
      borderStyle: "solid",
    },
    "&:focus": {
      backgroundColor: theme.palette.white.main,
      color: theme.palette.secondary.main,
      boxShadow: "3px #e6f7fd !important",
      fontWeight: "bold",
      borderWidth: "thin",
      borderColor: theme.palette.teal.main,
      borderStyle: "solid",
      "&:hover": {
        backgroundColor: theme.palette.white.main,
        color: theme.palette.secondary.tint90,
        boxShadow: "3px #e6f7fd !important",
      },
    },
    "&:disabled": {
      backgroundColor: theme.palette.white.main,
      color: theme.palette.secondary.tint90,
      opacity: "0.2",
      boxShadow: "none !important",
      borderWidth: "thin",
      borderColor: theme.palette.secondary.tint15,
      borderStyle: "solid",
      cursor: "no-drop",
    },
  },
  xs2:{
    padding: "6px",
    height: "36px",
    borderRadius: "8px",
    minWidth: "36px",
  },
  xs: {
    padding: "0px",
    height: "48px",
    borderRadius: "8px",
    minWidth: "48px",
  },
  small: {
    padding: "7px 16px",
    height: "30px",
    borderRadius: "4px",
  },
  medium: {
    padding: "6px 12px",
    height: "36px",
    borderRadius: "8px",
  },
  big: {
    padding: "12px 24px",
    height: "48px",
    borderRadius: "8px",
  },
  sharp: {
    padding: "12px 24px",
    height: "48px",
    borderRadius: "4px",
  },
  softRounded: {
    padding: "12px 24px",
    height: "48px",
    borderRadius: "8px",
  },
  rounded: {
    padding: "12px 24px",
    height: "48px",
    borderRadius: "11px",
  },
  text: {
    background: "none !important",
    border: "none !important",
    boxShadow: "none !important",
    height: "auto",
    padding: "0",
    "&:hover": {
      background: "none !important",
      border: "none !important",
      boxShadow: "none !important",
      color: "inherit",
    },
    "&:active": {
      background: "none !important",
      border: "none !important",
      boxShadow: "none !important",
      color: "inherit",
    },
    "&:focus": {
      background: "none !important",
      border: "none !important",
      boxShadow: "none !important",
      color: "inherit",
      "&:hover": {
        background: "none !important",
        border: "none !important",
        boxShadow: "none !important",
        color: "inherit",
      },
    },
    "&:disabled": {
      background: "none !important",
      border: "none !important",
      boxShadow: "none !important",
      color: "inherit",
      opacity: "0.5",
      cursor: "no-drop",
    },
    "&$primary": {
      color: theme.palette.primary.main,
    },
    "&$info": {
      color: theme.palette.teal.main,
    },
    "&$red2": {
      color: theme.palette.red2.main,
    },
    "&$default": {
      color: theme.palette.secondary.tint60,
    },
    "&$secondary": {
      color: theme.palette.secondary.tint60,
    },
  },
}));

const Button = ({
  loading,
  color,
  size,
  variant,
  startIcon,
  endIcon,
  className,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <MuiButton
      className={clsx(
        classes.root,
        classes[color],
        classes[size],
        classes[variant],
        className
      )}
      disabled={loading ? true : false}
      startIcon={loading ? <AutorenewIcon /> : startIcon}
      endIcon={endIcon}
      {...rest}
    />
  );
};
//color : primary , secondary, default, teal , red2, tertiary
//size : small , medium , big , sharp , softRounded , rounded
//variant : text , contained
export default Button;
